"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConversationalSearch = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _utils = require("@site/utils");
var _domainServices = require("@site/domain-services");
var _ConversationalSearchResults = require("./ConversationalSearchResults");
var _AiSearchBox = require("./AiSearchBox");
var _ConversationalSearch = require("../styles/ConversationalSearch");
var _uxUtils = require("@site/ux-utils");
var _classnames = _interopRequireDefault(require("classnames"));
var _sharedComponents = require("@site/shared-components");
var _ConversationalSearchComponentLoader = require("./ConversationalSearchComponentLoader");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line complexity
const ConversationalSearch = props => {
  const {
    language = {}
  } = {
    ...props
  };
  const {
    overrideProps,
    languageStrings,
    apm
  } = (0, _sharedComponents.useComponentDataProvider)(language);
  const {
    searchBoxPlaceholder = 'searchBoxPlaceholderText',
    enableDynamicFontScaling = false,
    urlOverride = '',
    apiKey,
    searchBoxIcon,
    numberOfResults = 40,
    plid = 1,
    onModalClose,
    tmsKey = '',
    options = {},
    AddToCartButton,
    PriceBlock,
    spinType = 'default',
    SpinsBlock,
    tccApiKeys = {},
    videoUrlsOverrides = {},
    hintsConfig = {},
    disableContinueToCart = false,
    continueToCartSkipConfig = false,
    isModal = true,
    searchQuery = '',
    hideSearchBox = false,
    hideResultsHeader = false,
    promptTitle,
    promptContent,
    showUserPrompt,
    showDomainPrompt = false,
    enableSearchVideo = true,
    stickySearchBox = false,
    topContentText,
    styling = {},
    exactBlockConfigs = {},
    resultsHeadingTextId,
    aiSearchBoxButtonClassName,
    welcomePageContent
  } = {
    ...props,
    ...overrideProps
  };
  const {
    isMobile,
    isDesktop
  } = (0, _uxUtils.useDeviceType)();
  const market = (0, _utils.getMarket)();
  const {
    findSpinsPromise,
    findExactPromise,
    findSmartExactPromise,
    host
  } = (0, _domainServices.initializeDomainServices)({
    apiKey,
    plid,
    urlOverride
  });
  const [exactApiResponseData, setExactApiResponseData] = (0, _react.useState)();
  const [smartExactApiResponseData, setSmartExactApiResponseData] = (0, _react.useState)();
  const [searchBoxInput, setSearchBoxInput] = (0, _react.useState)('');
  const [userSearchInput, setUserSearchInput] = (0, _react.useState)(searchQuery);
  const [previousInput, setPreviousInput] = (0, _react.useState)('');
  const [currentStep, setCurrentStep] = (0, _react.useState)(1);
  const [results, setResults] = (0, _react.useState)(null);
  const [isComponentVisible, setIsComponentVisible] = (0, _react.useState)(true);
  const phoenixEventMetadataObj = (0, _react.useMemo)(() => new _utils.PhoenixEventMetadata(), []);
  const {
    exactApiExtraParams,
    maxWordsForExactSearch,
    ExactMatchBlock,
    traceId,
    exactBlockMode = 'unified'
  } = exactBlockConfigs;
  (0, _react.useEffect)(() => {
    if (results && tccApiKeys[(0, _utils.getEnv)(urlOverride)]) {
      (0, _utils.sendConversationalSearchResultsEvent)({
        searchQuery: results?.IncludesPII ? '' : previousInput,
        source: apiKey,
        tmsKey,
        spinsResponse: results,
        currency: (0, _utils.getCurrency)(),
        phoenixEventMetadataObj,
        tccApiKeys
      });
    }
  }, [results, previousInput, apiKey, phoenixEventMetadataObj, tccApiKeys, urlOverride, tmsKey]);
  const validateError = searchTerm => {
    if (searchTerm) {
      if (searchTerm.length > 500) {
        setCurrentStep(413);
        return true;
      }
    } else {
      setCurrentStep(400);
      setSearchBoxInput('');
      return true;
    }
    return false;
  };
  const handleOnClose = event => {
    if (event.type === 'pointerup') {
      return;
    }
    onModalClose?.();
    setIsComponentVisible(false);
  };
  const validateAndCallApi = value => {
    const findApiCommonHeaders = (0, _domainServices.getFindApiHeaders)({
      referrer: document.referrer,
      isCypress: window.Cypress,
      ...(traceId && {
        traceparent: traceId
      })
    });
    const searchTerm = value.trim().replace(/(\r\n|\r|\n)/g, '');
    (0, _utils.logEvent)({
      eid: 'find.sales.aisearch.search.click',
      type: 'click',
      properties: {
        searchTerm
      }
    });
    setResults(null);
    setPreviousInput(searchTerm);
    const isValidationError = validateError(searchTerm);
    if (!isValidationError) {
      phoenixEventMetadataObj.setEventSent('isConversationalSearchEventSent', false);
      setCurrentStep(2);
      if (ExactMatchBlock && exactBlockMode === 'unified' && searchTerm.split(' ').length <= maxWordsForExactSearch) {
        const exactApiPromise = findExactPromise({
          query: searchTerm,
          options: {
            headers: findApiCommonHeaders
          },
          extraParams: exactApiExtraParams
        }).then(response => {
          return (0, _domainServices.commonResolve)(response);
        });
        const smartExactApiPromise = findSmartExactPromise({
          query: searchTerm,
          options: {
            headers: findApiCommonHeaders
          },
          extraParams: exactApiExtraParams
        }).then(response => {
          return (0, _domainServices.commonResolve)(response);
        });
        Promise.all([exactApiPromise, smartExactApiPromise]).then(([{
          data: exactData
        }, {
          data: smartExactData
        }]) => {
          setExactApiResponseData(exactData);
          setSmartExactApiResponseData(smartExactData);
        });
      } else {
        setExactApiResponseData(null);
        setSmartExactApiResponseData(null);
      }
      const spinsApiSpan = apm?.startSpan?.('spinsApi');
      const intentDetectionQS = options.intentDetectionProp && Object.keys(options.intentDetectionProp).length !== 0 ? {
        ...options.intentDetectionProp
      } : {
        intent: 'GenAI'
      };
      const spinsAiPromise = findSpinsPromise({
        query: searchTerm,
        extraParams: {
          ...{
            ...intentDetectionQS
          },
          pagesize: numberOfResults
        },
        options: {
          headers: findApiCommonHeaders
        }
      }).then(response => {
        spinsApiSpan?.end();
        return (0, _domainServices.commonResolve)(response);
      });
      Promise.all([spinsAiPromise]).then(([{
        data: spinsAiData
      }]) => {
        if (spinsAiData?.RecommendedDomains?.length > 0) {
          setResults(spinsAiData);
          setCurrentStep(3);
        } else {
          setResults(null);
          setCurrentStep(204);
        }
      }).catch(() => {
        setResults(null);
        setCurrentStep(404);
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (searchQuery) {
      setSearchBoxInput(searchQuery);
      setUserSearchInput(searchQuery);
      validateAndCallApi(searchQuery);
    }
  }, [searchQuery]);
  const onSubmit = e => {
    e.preventDefault();
    setUserSearchInput(searchBoxInput);
    validateAndCallApi(searchBoxInput);
  };
  const getConversationalSearchComponent = () => /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    messages: languageStrings
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('', {
      'conversational-search-modal-container': isModal
    })
  }, /*#__PURE__*/_react.default.createElement(_ConversationalSearchResults.ConversationalSearchResults, {
    language: languageStrings,
    currentStep: currentStep,
    results: results,
    host: host,
    enableDynamicFontScaling: enableDynamicFontScaling,
    videoUrlsOverrides: videoUrlsOverrides,
    ctaProps: {
      apiKey,
      market,
      env: (0, _utils.getEnv)(urlOverride),
      resellerBaseOverride: urlOverride,
      useDefaultContinueToCart: !disableContinueToCart,
      continueToCartSkipConfig,
      host,
      addProps: {
        'data-eid': 'find.sales.aisearch.buy.click'
      }
    },
    options: {
      market,
      ...options
    },
    AddToCartButton: AddToCartButton,
    PriceBlock: PriceBlock,
    spinType: spinType,
    SpinsBlock: SpinsBlock,
    isModal: isModal,
    hideResultsHeader: hideResultsHeader,
    showDomainPrompt: showDomainPrompt,
    enableSearchVideo: enableSearchVideo,
    topContentText: topContentText,
    userSearchInput: userSearchInput,
    promptTitle: promptTitle,
    promptContent: promptContent,
    showUserPrompt: showUserPrompt,
    isMobile: isMobile,
    exactBlockConfigs: {
      ExactMatchBlock,
      exactBlockMode
    },
    exactApiResponseData: exactApiResponseData,
    smartExactApiResponseData: smartExactApiResponseData,
    resultsHeadingTextId: resultsHeadingTextId,
    setSearchBoxInput: setSearchBoxInput,
    welcomePageContent: welcomePageContent
  }), !hideSearchBox && !(!enableSearchVideo && currentStep === 2) && /*#__PURE__*/_react.default.createElement(_AiSearchBox.AiSearchBox, {
    onChange: setSearchBoxInput,
    placeholder: searchBoxPlaceholder,
    roundedBottomBorder: true,
    onSubmit: onSubmit,
    value: searchBoxInput,
    icon: searchBoxIcon,
    hintsConfig: hintsConfig,
    stickySearchBox: stickySearchBox,
    aiSearchBoxButtonClassName: aiSearchBoxButtonClassName
  }), !hideSearchBox && !enableSearchVideo && currentStep === 2 && /*#__PURE__*/_react.default.createElement(_ConversationalSearchComponentLoader.AiSearchBoxComponentLoader, {
    stickySearchBox: stickySearchBox
  })));
  return isComponentVisible && (isModal ? /*#__PURE__*/_react.default.createElement(_ConversationalSearch.StyledModal, {
    title: "",
    id: "conversational-search-modal",
    onClose: handleOnClose,
    "data-testid": "conversational-search-modal",
    "data-cy": "conversational-search-modal"
  }, /*#__PURE__*/_react.default.createElement(_ConversationalSearch.StyledConversationalSearchWrapper, {
    isMobile: isMobile,
    isDesktop: isDesktop,
    styling: styling,
    isModal: isModal
  }, getConversationalSearchComponent())) : /*#__PURE__*/_react.default.createElement(_ConversationalSearch.StyledConversationalSearchWrapper, {
    styling: styling,
    isMobile: isMobile,
    isDesktop: isDesktop,
    "data-testid": "conversational-search",
    "data-cy": "conversational-search",
    isModal: isModal
  }, getConversationalSearchComponent()));
};
exports.ConversationalSearch = ConversationalSearch;
ConversationalSearch.propTypes = {
  searchBoxPlaceholder: _propTypes.default.string,
  urlOverride: _propTypes.default.string,
  apiKey: _propTypes.default.string.isRequired,
  language: _propTypes.default.object,
  searchBoxIcon: _propTypes.default.element,
  numberOfResults: _propTypes.default.number,
  plid: _propTypes.default.number,
  onModalClose: _propTypes.default.func,
  enableDynamicFontScaling: _propTypes.default.bool,
  options: _propTypes.default.shape({
    showPriceSavings: _propTypes.default.bool,
    displayPercentagePrice: _propTypes.default.bool,
    styleOverrides: _propTypes.default.object,
    dueTodayMessage: _propTypes.default.string,
    isListPricePriority: _propTypes.default.bool,
    isPriceLinePriority: _propTypes.default.bool,
    overrideCurrentPriceToZero: _propTypes.default.bool,
    term: _propTypes.default.number,
    hideListPrice: _propTypes.default.bool,
    showFreeIndicator: _propTypes.default.bool,
    isPromoForNewCustomer: _propTypes.default.bool
  }),
  styling: _propTypes.default.object,
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  spinType: _propTypes.default.oneOf(['default', 'tight-modern']),
  SpinsBlock: _propTypes.default.func,
  tmsKey: _propTypes.default.string,
  tccApiKeys: _propTypes.default.object,
  videoUrlsOverrides: _propTypes.default.object,
  hintsConfig: _propTypes.default.object,
  disableContinueToCart: _propTypes.default.bool,
  continueToCartSkipConfig: _propTypes.default.bool,
  isModal: _propTypes.default.bool,
  searchQuery: _propTypes.default.string,
  hideSearchBox: _propTypes.default.bool,
  hideResultsHeader: _propTypes.default.bool,
  promptTitle: _propTypes.default.string,
  promptContent: _propTypes.default.string,
  showDomainPrompt: _propTypes.default.bool,
  enableSearchVideo: _propTypes.default.bool,
  stickySearchBox: _propTypes.default.bool,
  topContentText: _propTypes.default.string,
  showUserPrompt: _propTypes.default.bool,
  exactBlockConfigs: _propTypes.default.shape({
    ExactMatchBlock: _propTypes.default.func,
    maxWordsForExactSearch: _propTypes.default.number,
    exactApiExtraParams: _propTypes.default.object,
    traceId: _propTypes.default.string
  }),
  resultsHeadingTextId: _propTypes.default.string,
  aiSearchBoxButtonClassName: _propTypes.default.string,
  welcomePageContent: _propTypes.default.shape({
    alignContent: _propTypes.default.string,
    welcomeVideo: _propTypes.default.shape({
      show: _propTypes.default.bool
    }),
    welcomeHeading1: _propTypes.default.shape({
      show: _propTypes.default.bool,
      text: _propTypes.default.string
    }),
    welcomeHeading2: _propTypes.default.shape({
      show: _propTypes.default.bool,
      text: _propTypes.default.string
    }),
    welcomeTextPara1: _propTypes.default.shape({
      show: _propTypes.default.bool,
      text: _propTypes.default.string
    }),
    promptSuggestionList: _propTypes.default.arrayOf(_propTypes.default.string)
  })
};
const ConversationalSearchWithComponentDataProvider = props => {
  const {
    appName,
    apiKey,
    plid,
    urlOverride,
    forceEnableBFF,
    options: {
      enableFavorites
    } = {},
    uipProps,
    isModal = true,
    searchQuery = ''
  } = props;
  const {
    isMobile,
    isDesktop
  } = (0, _uxUtils.useDeviceType)();
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.ComponentDataProvider, (0, _extends2.default)({
    appName: appName,
    componentName: "conversational-search",
    apiKey: apiKey,
    forceEnableBFF: forceEnableBFF,
    loader: /*#__PURE__*/_react.default.createElement(_ConversationalSearchComponentLoader.ConversationalSearchComponentLoader, {
      isModal: isModal,
      isMobile: isMobile,
      isDesktop: isDesktop,
      searchQuery: searchQuery
    })
  }, enableFavorites && {
    uipProps: {
      plid,
      urlOverride,
      ...uipProps
    }
  }), /*#__PURE__*/_react.default.createElement(ConversationalSearch, props));
};
ConversationalSearchWithComponentDataProvider.propTypes = {
  ...ConversationalSearch.propTypes,
  forceEnableBFF: _propTypes.default.bool
};
var _default = exports.default = ConversationalSearchWithComponentDataProvider;